import * as cardDirective from './card.directive.js';

export default angular.module('gazelle.components.dashboard.card', [
])
  .directive(cardDirective.name, cardDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/dashboard/card/card.module.js